import { SocieteCaracteristiqueChoixUpdate } from '@get/api-interfaces';
import { createActionGroup, props } from '@ngrx/store';

export const SocieteCaracteristiqueChoixActions = createActionGroup({
  source: 'Societe Caracteristique Choix',
  events: {
    'Handle Many Societe Caracteristique Choix': props<SocieteCaracteristiqueChoixUpdate>()
  }
});
